import { render, staticRenderFns } from "./auxiliaryResourcesDialog.vue?vue&type=template&id=0a684e02&scoped=true"
import script from "./auxiliaryResourcesDialog.vue?vue&type=script&lang=js"
export * from "./auxiliaryResourcesDialog.vue?vue&type=script&lang=js"
import style1 from "./auxiliaryResourcesDialog.vue?vue&type=style&index=1&id=0a684e02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a684e02",
  null
  
)

export default component.exports